// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination-simple_root__QJZAE","legend":"pagination-simple_legend__oSCy7","buttons":"pagination-simple_buttons___gVVM"};